import React, { useState } from 'react';
import { FunctionComponent } from 'react'
import { DownIcon } from '../Icons';
import RichText from '../RichText';
import './styles.scss';

type AccordionProps = {
  title: string;
  content: string | any;
  open?: boolean | null;
}

const Accordion: FunctionComponent<AccordionProps> = ({ title, content, open }) => {
  const [isOpen, setIsOpen] = useState<boolean>(open ? open : false);

  return (
    <div
      className={`accordion ${isOpen ? 'open' : ''}`}
    >
      <header onClick={(e) => { e.preventDefault(); setIsOpen((prev) => !prev) }}>
        <p><strong className='accordion-title'>{title}</strong></p>
        <DownIcon />
      </header>
      <section className='accordion-content'>
        {typeof content === 'string' ? (
          <p>{content}</p>
        ) : (
          <RichText value={content} />
        )}
      </section>
    </div>
  )
};

export default Accordion;
